
/* Redux */
import {useSelector} from "react-redux";
import {RootState} from "../redux";
import {IResultsState, ISelected} from "../types/redux/result";
import {useCallback} from "react";

const useSearchResults = (): { selectedRecords: Function } => {
  const resultsState: IResultsState = useSelector<RootState, IResultsState>(state => state.result);

  const selectedRecords = useCallback((): any[] =>{
    const records: any[] = [];
    resultsState.selected_ids.forEach((selectedId:ISelected)=> {
      const result: any = resultsState.results.find(result=>result.id === selectedId.id);
      if (result) {
        records.push(result)
      }
    })
    return records
  },[resultsState.results, resultsState.selected_ids]);

  return {
    selectedRecords
  }
};

export default useSearchResults;
